export const calendarList = {
    GET_LIST_CALENDAR_EVENTS: "GET_LIST_CALENDAR_EVENTS",
    GET_LIST_CALENDAR_EVENTS_SUCCESS : "GET_LIST_CALENDAR_EVENTS_SUCCESS",
    GET_LIST_CALENDAR_EVENTS_NULL : "GET_LIST_CALENDAR_EVENTS_NULL",
    GET_LIST_CALENDAR_EVENTS_ERROR : "GET_LIST_CALENDAR_EVENTS_ERROR",
    CLEAR_FILTERS: "CLEAR_FILTERS",
    CLEAR_CALENDAR_EVENTS_LIST: "CLEAR_CALENDAR_EVENTS_LIST"
}